export const SITE_SET_DATA = 'SITE_SET_DATA';

export const siteSetData = (data) => ({
    type: SITE_SET_DATA,
    payload: data
});